import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Customer360Service } from 'src/app/private/services/customer-360.service';
import { LeadActivityFeedItem } from '../lead-activity-feed/lead-activity-feed.component';
import { activityTypeLabel, captureChannelLabel } from 'src/app/utils/customer-360-labels.util';

@Component({
  selector: 'app-lead-profile-loyalty',
  templateUrl: './lead-profile-loyalty.component.html',
  styleUrls: ['./lead-profile-loyalty.component.scss'],
})
export class LeadProfileLoyaltyComponent implements OnChanges {
  @Input() leadId: number | string | null = null;
  @Input() refreshToken = 0;

  pointsBalance = 0;
  tier = 'standard';
  offers: any[] = [];
  items: LeadActivityFeedItem[] = [];
  loading = false;
  shoppingType = '';
  dominantActivityType = '';
  dominantCaptureChannel = '';

  activityLabel = activityTypeLabel;
  captureLabel = captureChannelLabel;

  constructor(private customer360: Customer360Service) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leadId'] || changes['refreshToken']) {
      this.load();
    }
  }

  load(): void {
    if (this.leadId == null || this.leadId === '') {
      return;
    }
    this.loading = true;
    this.customer360.getCustomerLoyalty(this.leadId).subscribe({
      next: (res: any) => {
        this.pointsBalance = res?.account?.points_balance ?? 0;
        this.tier = res?.account?.tier || 'standard';
        this.items = (res?.transactions ?? []).map((row: any) => ({
          id: row.id,
          actorName: 'Loyalty',
          createdAt: row.createdAt,
          body: `${row.points_delta >= 0 ? '+' : ''}${row.points_delta} pts — ${row.reason || 'Adjustment'}`,
          raw: row,
        }));
      },
      error: () => {
        this.pointsBalance = 0;
        this.items = [];
      },
    });

    this.customer360.getCustomerOffers(this.leadId).subscribe({
      next: (rows: any) => {
        this.offers = Array.isArray(rows) ? rows : [];
      },
      error: () => {
        this.offers = [];
      },
    });

    this.customer360.getCustomerBehaviorSummary(this.leadId).subscribe({
      next: (summary: any) => {
        this.shoppingType = summary?.shopping_type || '';
        this.dominantActivityType = summary?.dominant_activity_type || '';
        this.dominantCaptureChannel = summary?.dominant_channel || '';
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
